/* eslint-disable react/prop-types */
import React from 'react'
import { Container, Nav } from 'react-bootstrap'
import handleScroll from '~utils/handleScroll'
import Icon from '~components/Icon'
import cn from 'classnames'

import * as s from './SubNav.module.scss'

const SubNav = ({ data, className, variant = 'hero' }) => {
  const variantSets = {
    hero: {
      container: s.sub_wrapper,
      nav: s.subnav,
    },
    top: {
      container: 'fixed z-[9999] bg-gray-100 w-full !max-w-full shadow',
      nav: '',
    },
  }
  return (
    <Container className={cn(variantSets[variant].container, className)}>
      <nav className={cn(variantSets[variant].nav)}>
        <Nav className="container" variant="sub" as="ul">
          {data.map(({ title, link, isExternal }) => {
            const linkProps = isExternal
              ? { target: '_blank', className: s.subnav_external }
              : { onClick: (e) => handleScroll(e, link) }

            return (
              <Nav.Item key={title} as="li">
                <Nav.Link
                  href={link}
                  {...linkProps}
                  active={false}
                  className={s.subnav_link}
                >
                  {title}
                  {isExternal && (
                    <Icon
                      className={s.subnav_icon}
                      name="icon-arrow-up-solid"
                      size={7}
                    />
                  )}
                </Nav.Link>
              </Nav.Item>
            )
          })}
        </Nav>
      </nav>
    </Container>
  )
}

export default SubNav
